import { Icon } from '@iconify/react';
import classnames from "classnames";
import Button from '../button';
import Styles from "./styles.module.scss";
import {useState } from "react";
import AddComments from "../../modal/addComments";
import FormHead from "../../components/headings/FromHead";
import { FormAreaInput } from "../../wrappers/formArea";
import { Error } from '@progress/kendo-react-labels';



function CommentBox(props: any) {


  const [newComment, setNewComment] = useState<string>('')
  const name = localStorage.getItem('Name')
  const [error, setError] = useState<string>('')

  const handleChange = (e: any) => {
    setError('')
    setNewComment(e.target.value)
  }

  const onSubmit = (event: any) => {
    event.preventDefault()
    if (newComment && newComment !== '') {
      props.clickHandler(newComment)
      setNewComment('')
    }
    else {
      setError('Field is required')
    }
  }

  return (
    <>
        
        {<section className={Styles.commentBoxWrap}>
          <div className={Styles.commentsArea}>
            <FormHead>Comments ({props.data && props.data.length})</FormHead>
            <div className={classnames("form-group", Styles.commentForm)}>
            <figure className={Styles.userPic}>{name && name.split(' ')[0][0] + name.split(' ')[1][0]}</figure>
                <FormAreaInput value={newComment} name="comments" onChange={handleChange}/>
          </div>
          <Error>{error}</Error>
            <div className={Styles.addLink}>
                <Button variant="primary" onClick={onSubmit}>Add Comments</Button>
            </div>
          </div>

            <div className={Styles.commentScroll}>
            {props && props.data && props.data.length > 0 && props.data.map((item: any) => {
              return (
                <div className={Styles.commentItem}>
                  <figure className={Styles.userPic}>{item.recruiterName && item.recruiterName.split(' ')[0][0] + item.recruiterName.split(' ')[1][0] }</figure>
                  <div className={Styles.commentData}>
                    <h4>{item.recruiterName}<span>{new Date(item.date).toDateString().slice(3) }</span></h4>
                    <p>{item.comment}</p>
                  </div>
                </div>
              )
            })}       
            </div>
        </section>}

      {/* {addComment && <AddComments onClose={() => setAddComment(false)} clickHandler={(data: any) => { props.clickHandler(data); setAddComment(false)}} />} */}
    </>
  )
}


export default CommentBox